import(/* webpackMode: "eager", webpackExports: ["AppBar","Toolbar","Stack"] */ "__barrel_optimize__?names=AppBar,Stack,Toolbar!=!/app/node_modules/@mui/material/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "__barrel_optimize__?names=Box!=!/app/node_modules/@mui/material/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/logo.png");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderItem"] */ "/app/src/components/generic/Header/HeaderItem/HeaderItem.tsx");
